import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.pxSmall,
    fontSize: '0.68rem',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

function AuthorSubitle({ data, align }) {
  const classes = useStyles();
  if (_isEmpty(data) || (!_isEmpty(data) && data.length > 1)) return null;
  const finalData =
    _get(data, '0.fields.title', '') || _get(data, '0.fields.title', '');
  return (
    <Typography align={align} className={classes.root} color="textPrimary">
      {finalData}
    </Typography>
  );
}

AuthorSubitle.propTypes = {
  data: PropTypes.array,
  align: PropTypes.string,
};

AuthorSubitle.defaultProps = {
  align: 'left',
};

export default AuthorSubitle;
